import {
  PaymentMethod,
  PAYMENT_METHOD_DISPLAY,
  CHECK_IN_PAYMENT_METHODS,
} from "@mimber/schema"

// Mirrors CHECK_IN_PAYMENT_METHODS from @mimber/schema so the UI can never
// offer a payment method (e.g. CARD, ACH) that the check-in DTO would reject.
export const CHECK_IN_PAYMENT_METHOD_OPTIONS = (
  Object.entries(PAYMENT_METHOD_DISPLAY) as [PaymentMethod, { label: string }][]
)
  .filter(([value]) =>
    (CHECK_IN_PAYMENT_METHODS as readonly PaymentMethod[]).includes(value)
  )
  .map(([value, { label }]) => ({ label, value }))
